import { CommonModel } from '@telialt/models/src/CommonModel';
import { axiosForHybris } from '@telialt/utils/src/axios/axiosForHybris';
import { withParams } from '@telialt/utils/src/helpers';

import { API } from './constants';
import { LeadSmsConfirmRequestData, LeadSubmitRequestData, LeadSubmitResponse } from './model';

export const submitLead = (leadData: LeadSubmitRequestData, segment: CommonModel.Segment) =>
    axiosForHybris.post<LeadSubmitResponse>(withParams(API.URL_LEAD_SUBMIT, { segment }), leadData);

export const submitSmsConfirm = (confirmData: LeadSmsConfirmRequestData) =>
    axiosForHybris.post<LeadSubmitResponse>(API.URL_LEAD_SMS_CONFIRM, confirmData);
